import React, { Component } from 'react';
import {
  BILLING_IDLE_TIMEOUT_MS,
  getBillingIdleRemainingMs,
  subscribeBillingIdleCountdown,
} from '../billingSessionTimeout';

function formatCountdown(remainingMs) {
  const totalSec = Math.max(0, Math.ceil(remainingMs / 1000));
  const minutes = Math.floor(totalSec / 60);
  const seconds = totalSec % 60;
  return minutes + ':' + String(seconds).padStart(2, '0');
}

class SessionTimeoutCountdown extends Component {
  state = {
    remainingMs: getBillingIdleRemainingMs(),
  };

  componentDidMount() {
    this.unsubscribe = subscribeBillingIdleCountdown((remainingMs) => {
      this.setState({ remainingMs });
    });
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  render() {
    if (!localStorage.getItem('UserId')) {
      return null;
    }

    const { remainingMs } = this.state;
    const isUrgent = remainingMs <= 60 * 1000;
    const totalMinutes = Math.max(1, Math.round(BILLING_IDLE_TIMEOUT_MS / 60000));
    const totalSeconds = Math.round(BILLING_IDLE_TIMEOUT_MS / 1000);
    const timeoutLabel = totalSeconds % 60 === 0
      ? (totalMinutes + ' minutes')
      : (totalSeconds + ' seconds');

    return (
      <li className="nav-item nav-session-timeout d-flex align-items-center">
        <div
          className={'nav-session-timeout-box' + (isUrgent ? ' is-urgent' : '')}
          title={'Session auto sign-out after ' + timeoutLabel + ' idle'}
          aria-label={'Session timeout ' + formatCountdown(remainingMs) + ' remaining'}
        >
          <i className="mdi mdi-timer-outline nav-session-timeout-icon" aria-hidden="true"></i>
          <span className="nav-session-timeout-label">Session</span>
          <span className="nav-session-timeout-value">{formatCountdown(remainingMs)}</span>
        </div>
      </li>
    );
  }
}

export default SessionTimeoutCountdown;
